import React from 'react';
import {
  Box,
  Typography,
  Switch,
  TextField,
  MenuItem,
  Paper,
  FormHelperText,
} from '@mui/material';
import {
  getDayName,
  snapTimeToStep,
  TIME_SLOT_OPTIONS,
} from '../../utils/reservableHelpers';

const AvailabilityWeekGrid = ({ weekSchedule, onChange, error }) => {
  const handleDayChange = (dayOfWeek, field, value) => {
    const normalized =
      field === 'startTime' || field === 'endTime' ? snapTimeToStep(value) : value;
    onChange(
      weekSchedule.map((day) =>
        day.dayOfWeek === dayOfWeek ? { ...day, [field]: normalized } : day
      )
    );
  };

  return (
    <Box>
      <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600 }}>
        Disponibilità settimanale
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Attiva i giorni in cui la risorsa è prenotabile e imposta fascia oraria.
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {weekSchedule.map((day) => (
          <Paper
            key={day.dayOfWeek}
            variant="outlined"
            sx={{
              p: 2,
              opacity: day.enabled ? 1 : 0.7,
              borderColor: day.enabled ? 'primary.light' : 'divider',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: 2,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 160 }}>
                <Switch
                  checked={day.enabled}
                  onChange={(e) =>
                    handleDayChange(day.dayOfWeek, 'enabled', e.target.checked)
                  }
                />
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {getDayName(day.dayOfWeek)}
                </Typography>
              </Box>

              <TextField
                select
                label="Inizio"
                size="small"
                value={day.startTime}
                disabled={!day.enabled}
                onChange={(e) =>
                  handleDayChange(day.dayOfWeek, 'startTime', e.target.value)
                }
                InputLabelProps={{ shrink: true }}
                sx={{ width: 140 }}
              >
                {TIME_SLOT_OPTIONS.map((time) => (
                  <MenuItem key={`start-${time}`} value={time}>
                    {time}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                select
                label="Fine"
                size="small"
                value={day.endTime}
                disabled={!day.enabled}
                onChange={(e) =>
                  handleDayChange(day.dayOfWeek, 'endTime', e.target.value)
                }
                InputLabelProps={{ shrink: true }}
                sx={{ width: 140 }}
              >
                {TIME_SLOT_OPTIONS.map((time) => (
                  <MenuItem key={`end-${time}`} value={time}>
                    {time}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          </Paper>
        ))}
      </Box>

      {error && (
        <FormHelperText error sx={{ mt: 1 }}>
          {error}
        </FormHelperText>
      )}
    </Box>
  );
};

export default AvailabilityWeekGrid;
